import { Component, OnInit, ViewChild, ElementRef, HostListener } from '@angular/core';

interface Point { x: number; y: number; }
interface DamagePopup { x: number; y: number; value: number; expires: number; }
type SkillType = 'glove' | 'staff' | 'bow';
interface SkillItem { x: number; y: number; type: SkillType; }
/*
**目前 Snake 小遊戲規則總覽** 

**📍 基礎玩法 & 狀態**  
- **蛇身繪製**：用 🐍 做蛇頭、🟩 做蛇身，畫布背景草綠呈現草地。  
- **移動控制**：流暢方向緩衝，防止同一幀反向誤判；空格鍵暫停/繼續（半透明⏸️遮罩）。  
- **邊界穿越**：碰到邊緣會從對側出現。  
- **自撞即死**：蛇頭撞到身體立刻結束遊戲。

**🔴 BOSS 戰機制**  
- **血量條**：初始1000/1000，頂端進度條顯示，底色灰、填充紅。  
- **速度變化**：Boss 血越少，蛇速越快；100% HP＝1×、0 HP＝1.5×（線性插值）。  
- **計時器**：從開始玩／重置起計秒，結束時顯示「用時 X 秒」。

**🍗⚔️ 一般食物**  
- **雞腿 🍗**：畫面中「雞腿」圖示，不再回復 BOSS 血量。  
- **武器 ⚔️**：累積計數；每吃 3 把增加蛇身一格，蛇身長度每多10格，需要的把數+1。狀態列 0–2 把以小圖示顯示。
- **武器跟雞腿的生成機率為武器80% 雞腿20%

**💥 傷害浮字**  
- 對 BOSS 造成傷害（吃武器或特殊攻擊）時，在碰撞點浮現傷害量，持續 2–3 秒後消失。

**💪🛡️ 特殊強化**  
- **肌肉臂 💪**：攻擊力 +50% (10 秒)，攻擊傷害計算階段倍率生效，蛇體描紅光環。  
- **盾牌 🛡️**：護盾 (10 秒)，期間障礙/地雷減少一層懲罰，蛇體描綠光環。

**⛰️ 障礙物**  
- Boss 每損失 10% 血量時隨機生成 10 個障礙，不會出現在蛇頭前方 5 格；碰撞時依護盾規則減少段數。

**💣 地雷**  
- HP ≤ 20% 時每 5 秒生成 2 個地雷，不在蛇頭前 5 格；HP > 20% 時場上清除；碰撞時依護盾規則減段。

**🦇 蝙蝠**  
- HP ≤ 50% 時每 3 秒出現 1 隻蝙蝠，HP > 50% 時場上清除；吃到蝙蝠扣 1 格並回復 BOSS 血量＝蛇長×5。

**💀 骷髏**  
- HP ≤ 10% 時隨機生成 20 個骷髏；碰撞啟動 20 秒「雙倍回血」效果，傷害時回血量×2，蛇體描黑光環，HP > 10% 清除場上骷髏。

**🏁 遊戲結束**  
- Boss HP ≤ 0 或蛇自撞時結束，顯示灰色半透明遮罩與「遊戲結束／用時 X 秒」。
- 玩家蛇身數<1結束
-----
新增以下機制：
1.技能道具
    生成：每15秒在場地上隨機刷新出3個，每次刷新會將場地上其他技能道具清除
    類型： 三種=拳套,法杖,弓箭
    效果：每吃滿三個技能道具以後，判斷最近吃滿的三格若符合以下組合，便造成以下效果
        1.三個拳套(重擊)：對BOSS造成一次攻擊力3倍的傷害
        2.三個法杖(燃燒)：每秒鐘對BOSS造成一次當前攻擊力30%的傷害，持續10秒
        3.三個弓箭(追擊)：10秒內吃到任何東西時，都會對BOSS造成BOSS當前血量1%的傷害
        4.拳套法杖弓箭各一(淨化)：清除場上所有的地雷/障礙物/蝙蝠/骷髏，並且按照清除的物件總數=X，對BOSS造成最大血量的X%傷害，不超過5%
        達成效果(技能發動)後清空已蒐集的技能道具清單(需要重新蒐集)
    UI：在遊戲區上方顯示目前吃到的項目最近的三格的技能道具，當技能發動時要在BOSS血量附近顯示發動的技能名稱與造成的傷害
2.BOSS血量每減少10%會無敵5秒鐘，無敵期間不會受到任何傷害都會變0，治療正常生效，血條顏色暫時變成藍色。
3.當玩家碰到障礙物或地雷，造成自身長度簡短的時候，根據簡短的數量，BOSS獲得鎧甲，鎧甲數量要顯示在血條正下方排列開來呈現。
    鎧甲效果：當BOSS受到任何傷害時，根據鎧甲數量降低受到的傷害量，不得低於1
    當玩家每5次吃到武器對BOSS造成傷害時可以削減一層BOSS的鎧甲，最多削減至0層
-----
1.加入飽食度設定
  初始有1000點飽食度，上限1000
  每移動一格-1
  當飽食度越低的時候造成的傷害越低:
      造成傷害=原本傷害* 飽食度百分比
  當吃到雞腿的時候飽食度恢復至全滿
----
TODO:
  結束訊息:要顯示過程中一共倒下了多少夥伴(被扣除過的蛇身次數)，列出EMOJI
  飽食度影響遊戲速度 = 基本遊戲速度*(1+boss血量影響% - (飽食度%/2))
  物件不能重疊在同一格上
  BOSS當受到傷害導致血量低於20時，該次傷害降低至1
  夥伴技能：當擁有夥伴的時候可以用數字鍵1-9來釋放對應的技能
    每種EMOJI技能待設計，技能需有冷卻時間，需要有UI來提示
  加入各種物件說明
  加入技能說明
*/
@Component({
  selector: 'app-snack',
  templateUrl: './snack.component.html',
  styleUrls: ['./snack.component.css']
})
export class SnackComponent implements OnInit {
  @ViewChild('canvas', { static: true }) canvasRef!: ElementRef<HTMLCanvasElement>;
  private ctx!: CanvasRenderingContext2D;
  private snake: Point[] = [];
  private direction: Point = { x: 1, y: 0 };
  private nextDirection: Point = { x: 1, y: 0 };
  private food!: Point;
  private intervalId!: number;
  private readonly cellSize = 20;
  private readonly cols = 20;
  private readonly rows = 20;

  // (scoring logic removed)
  public paused = false;
  public gameOver = false;
  public specialFood?: { x: number; y: number; type: number };
  public foodType!: 'chicken' | 'weapon';
  // BOSS battle state
  public bossHp = 1000;
  public bossMaxHp = 1000;
  private startTime = 0;
  private elapsedTime = 0;
  private gameTimerId!: number;
  private baseInterval = 200;
  private attackBuffFactor = 1;
  public shieldActive = false;
  public skeletonActive = false;
  private specialIntervalId!: number;
  private mineIntervalId!: number;
  private nextObstacleThreshold!: number;
  public obstacles: Point[] = [];
  public mines: Point[] = [];
  public bats: Point[] = [];
  public skeletons: Point[] = [];
  public skillItems: SkillItem[] = [];
  public skillQueue: SkillType[] = [];
  public skillMessage?: { text: string; damage: number | null; expires: number };
  public bossArmor = 0;
  public satiety = 1000;
  public satietyLabel = '🍽️';

  private invulnerableUntil = 0;
  private invulnTimeoutId!: number;
  private nextInvulnThreshold!: number;
  private skillIntervalId!: number;
  private burnIntervalId!: number;
  private burnTicksRemaining = 0;
  private arrowTimeoutId!: number;
  private arrowActiveUntil = 0;
  private skillMessageTimeoutId!: number;
  private weaponDamageHits = 0;
  private readonly maxSatiety = 1000;
  private readonly bodyEmojiOptions = ['🐲','🐯','🐶','🥷🏿','🧙','🦁','🦅','🧝🏼‍♂️','🧝🏻','🦍'];
  private segmentEmojis: string[] = [];
  private pendingTailSkips = 0;
  public burnTickDamage: number | null = null;
  private readonly navigationKeys = new Set(['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', ' ']);
  
  private skeletonTimeoutId!: number;
  private batIntervalId!: number;
  private skeletonsTriggered = false;
  public show = false;
  effectSpeedFactor =1
  public weaponCharge = 0;
  public weaponSlots = [0, 1, 2];
  private damagePopups: DamagePopup[] = [];
  private readonly damagePopupDuration = 2500;

  public get baseAttackPower(): number {
    return this.snake.length;
  }

  public get buffedAttackPower(): number {
    return Math.floor(this.snake.length * this.attackBuffFactor);
  }

  public get satietyPercent(): number {
    return Math.floor((this.satiety / this.maxSatiety) * 100);
  }

  public get isBurning(): boolean {
    return this.burnTicksRemaining > 0;
  }

  private getSatietyRatio(): number {
    //if (this.maxSatiety === 0) return 0;
    return Math.max(0, Math.min(1, this.satiety / this.maxSatiety));
  }

  private getWeaponRequirement(): number {
    return 3 + Math.floor(this.snake.length / 10);
  }
  
  
  ngOnInit(): void {
    this.ctx = this.canvasRef.nativeElement.getContext('2d')!;
    this.resetGame();
  }

  public open(): void {
    this.show = true;
  }

  public close(): void {
    clearInterval(this.intervalId);
    clearInterval(this.specialIntervalId);
    clearInterval(this.skillIntervalId);
    this.clearBurnEffect();
    if (this.arrowTimeoutId) clearTimeout(this.arrowTimeoutId);
    if (this.skillMessageTimeoutId) clearTimeout(this.skillMessageTimeoutId);
    if (this.invulnTimeoutId) clearTimeout(this.invulnTimeoutId);
    this.show = false;
  }

  public resetGame(): void {
    clearInterval(this.intervalId);
    this.snake = [{ x: 10, y: 10 }];
    this.segmentEmojis = [];
    this.pendingTailSkips = 0;
    this.direction = { x: 1, y: 0 };
    this.nextDirection = { x: 1, y: 0 };
    this.spawnNormal();
    this.paused = false;
    this.gameOver = false;
    this.bossHp = this.bossMaxHp;
    this.satiety = this.maxSatiety;
    this.weaponCharge = 0;
    this.damagePopups = [];
    this.startTime = Date.now();
    clearInterval(this.gameTimerId);
    this.elapsedTime = 0;
    this.gameTimerId = window.setInterval(() => {
      this.elapsedTime = Math.floor((Date.now() - this.startTime) / 1000);
    }, 1000);
    this.effectSpeedFactor = 1;
    clearInterval(this.specialIntervalId);
    this.specialFood = undefined;
    this.specialIntervalId = window.setInterval(() => this.spawnSpecial(), 10000);
    clearInterval(this.mineIntervalId);
    this.mines = [];
    this.mineIntervalId = window.setInterval(() => this.spawnMines(), 5000);
    this.nextObstacleThreshold = this.bossMaxHp * 0.9;
    this.obstacles = [];
    this.updateInterval();
    clearInterval(this.skillIntervalId);
    this.skillItems = [];
    this.skillQueue = [];
    this.skillMessage = undefined;
    clearTimeout(this.skillMessageTimeoutId);
    this.bossArmor = 0;
    this.weaponDamageHits = 0;
    this.invulnerableUntil = 0;
    clearTimeout(this.invulnTimeoutId);
    this.nextInvulnThreshold = this.bossMaxHp * 0.9;
    this.arrowActiveUntil = 0;
    clearTimeout(this.arrowTimeoutId);
    this.clearBurnEffect();
    this.skeletonsTriggered = false;
    this.startSkillSpawner();
    // initial render
    this.draw();
    clearInterval(this.batIntervalId);
    this.bats = [];
    this.batIntervalId = window.setInterval(() => this.spawnBats(), 3000);
    clearTimeout(this.skeletonTimeoutId);
    this.skeletons = [];
  }

  private spawnNormal(): void {
    let pos: Point;
    do {
      pos = {
        x: Math.floor(Math.random() * this.cols),
        y: Math.floor(Math.random() * this.rows)
      };
    } while (this.snake.some(p => p.x === pos.x && p.y === pos.y));
    this.food = pos;
    this.foodType = Math.random() < 0.8 ? 'weapon' : 'chicken';
  }

  private growSnake(segments: number): void {
    if (segments <= 0 || this.snake.length === 0) return;
    const tail = this.snake[this.snake.length - 1];
    for (let i = 0; i < segments; i++) {
      this.snake.push({ x: tail.x, y: tail.y });
      this.segmentEmojis.push(this.randomBodyEmoji());
    }
    this.pendingTailSkips += segments;
  }

  private randomBodyEmoji(): string {
    return this.bodyEmojiOptions[Math.floor(Math.random() * this.bodyEmojiOptions.length)];
  }

  private addBodySegment(): void {
    this.segmentEmojis.push(this.randomBodyEmoji());
  }

  private removeTailSegments(count: number): number {
    let removed = 0;
    while (removed < count && this.snake.length > 0) {
      this.snake.pop();
      if (this.segmentEmojis.length > 0) {
        this.segmentEmojis.pop();
      }
      removed++;
    }
    this.pendingTailSkips = Math.max(0, this.pendingTailSkips - removed);
    return removed;
  }

  private addDamagePopup(position: Point, value: number): void {
    this.damagePopups.push({
      x: position.x,
      y: position.y,
      value,
      expires: Date.now() + this.damagePopupDuration
    });
  }

  private gameLoop(): void {
    this.direction = this.nextDirection;

    const head: Point = {
      x: (this.snake[0].x + this.direction.x + this.cols) % this.cols,
      y: (this.snake[0].y + this.direction.y + this.rows) % this.rows
    };

    this.satiety = Math.max(0, this.satiety - 1);

    if (this.snake.some(p => p.x === head.x && p.y === head.y)) {
      this.endGame();
      return;
    }

    this.snake.unshift(head);
    this.addBodySegment();

    const skillIdx = this.skillItems.findIndex(item => item.x === head.x && item.y === head.y);
    if (skillIdx >= 0) {
      const skill = this.skillItems.splice(skillIdx, 1)[0];
      this.collectSkillItem(skill.type);
      this.onItemCollected();
      this.removeTailSegments(1);
    } else if (this.skeletons.findIndex(s => s.x === head.x && s.y === head.y) >= 0) {
      this.skeletonActive = true;
      clearTimeout(this.skeletonTimeoutId);
      this.skeletonTimeoutId = window.setTimeout(() => this.skeletonActive = false, 20000);
      this.skeletons = [];
      this.removeTailSegments(1);
    } else if (this.bats.some(b => b.x === head.x && b.y === head.y)) {
      const idx = this.bats.findIndex(b => b.x === head.x && b.y === head.y);
      if (this.snake.length > 0) this.snake.pop();
      this.bossHp = Math.min(this.bossMaxHp, this.bossHp + this.snake.length * 5);
      this.bats.splice(idx, 1);
      this.removeTailSegments(1);
    } else if (this.obstacles.some(o => o.x === head.x && o.y === head.y)) {
      const idx = this.obstacles.findIndex(o => o.x === head.x && o.y === head.y);
      const pops = this.shieldActive ? 1 : 2;
      const removed = this.removeTailSegments(pops);
      if (removed > 0) this.bossArmor += removed;
      this.obstacles.splice(idx, 1);
    } else if (this.mines.some(m => m.x === head.x && m.y === head.y)) {
      const idx = this.mines.findIndex(m => m.x === head.x && m.y === head.y);
      const pops = this.shieldActive ? 2 : 3;
      const removed = this.removeTailSegments(pops);
      if (removed > 0) this.bossArmor += removed;
      this.mines.splice(idx, 1);
    } else if (this.specialFood && head.x === this.specialFood.x && head.y === this.specialFood.y) {
      this.consumeSpecial();
      this.onItemCollected();
    } else if (head.x === this.food.x && head.y === this.food.y) {
      if (this.foodType === 'weapon') {
        const dmg = Math.floor(this.snake.length * this.attackBuffFactor);
        this.applyBossDamage(dmg, { location: head, source: 'weapon' });
        this.weaponCharge++;
        const requirement = this.getWeaponRequirement();
        if (this.weaponCharge >= requirement) {
          this.weaponCharge = Math.max(0, this.weaponCharge - requirement);
          this.growSnake(1);
        }
        if (this.bossHp <= 0) {
          return;
        }
      } else {
        this.satiety = this.maxSatiety;
      }
      
      this.removeTailSegments(1);
      this.spawnNormal();
      this.onItemCollected();
    } else {
      if (this.pendingTailSkips > 0) {
        this.pendingTailSkips--;
      } else {
        this.removeTailSegments(1);
      }
    }

    if (this.snake.length<1) {
      this.endGame();
      return;
    }
    if (this.bossHp <= this.nextObstacleThreshold && this.nextObstacleThreshold >= this.bossMaxHp * 0.1) {
      this.spawnObstacles();
      this.nextObstacleThreshold -= this.bossMaxHp * 0.1;
    }

    if (this.bossHp <= this.bossMaxHp * 0.1) {
      if (!this.skeletonsTriggered) {
        this.spawnSkeletons();
        this.skeletonsTriggered = true;
      }
    } else {
      this.skeletonsTriggered = false;
      if (this.skeletons.length > 0) this.skeletons = [];
    }

    this.draw();
  }
  private draw(): void {
    const canvas = this.canvasRef.nativeElement;
    this.ctx.clearRect(0, 0, canvas.width, canvas.height);
    this.ctx.fillStyle = '#7cc47a';
    this.ctx.fillRect(0, 0, canvas.width, canvas.height);

    const now = Date.now();
    this.damagePopups = this.damagePopups.filter(p => p.expires > now);

    this.ctx.textAlign = 'center';
    this.ctx.textBaseline = 'middle';
    const emojiFont = `${this.cellSize}px "Segoe UI Emoji", "Apple Color Emoji", sans-serif`;
    this.ctx.font = emojiFont;

    this.ctx.fillStyle = '#1b5e20';
    for (let i = 0; i < this.snake.length; i++) {
      const p = this.snake[i];
      const emoji = i === 0 ? '🤴🏻' : (this.segmentEmojis[i - 1] ?? '🟩');
      this.ctx.fillText(
        emoji,
        p.x * this.cellSize + this.cellSize / 2,
        p.y * this.cellSize + this.cellSize / 2
      );
    }

    const foodIcon = this.foodType === 'weapon' ? '⚔️' : '🍗';
    this.ctx.fillStyle = '#fff';
    this.ctx.fillText(
      foodIcon,
      this.food.x * this.cellSize + this.cellSize / 2,
      this.food.y * this.cellSize + this.cellSize / 2
    );

    if (this.specialFood) {
      const specialIcons: Record<number, string> = {
        1: '💪',
        2: '🛡️',
        3: '🪨',
        4: '💣'
      };
      const icon = specialIcons[this.specialFood.type] ?? '✨';
      this.ctx.fillText(
        icon,
        this.specialFood.x * this.cellSize + this.cellSize / 2,
        this.specialFood.y * this.cellSize + this.cellSize / 2
      );
    }

    for (const skill of this.skillItems) {
      this.ctx.fillText(
        this.skillIcon(skill.type),
        skill.x * this.cellSize + this.cellSize / 2,
        skill.y * this.cellSize + this.cellSize / 2
      );
    }

    this.ctx.fillStyle = '#6d4c41';
    for (const o of this.obstacles) {
      this.ctx.fillText(
        '🪨',
        o.x * this.cellSize + this.cellSize / 2,
        o.y * this.cellSize + this.cellSize / 2
      );
    }

    this.ctx.fillStyle = '#333';
    for (const s of this.skeletons) {
      this.ctx.fillText(
        '💀',
        s.x * this.cellSize + this.cellSize / 2,
        s.y * this.cellSize + this.cellSize / 2
      );
    }

    this.ctx.fillStyle = '#0d47a1';
    for (const b of this.bats) {
      this.ctx.fillText(
        '🦇',
        b.x * this.cellSize + this.cellSize / 2,
        b.y * this.cellSize + this.cellSize / 2
      );
    }

    this.ctx.fillStyle = '#f57f17';
    for (const m of this.mines) {
      this.ctx.fillText(
        '💣',
        m.x * this.cellSize + this.cellSize / 2,
        m.y * this.cellSize + this.cellSize / 2
      );
    }

    for (const popup of this.damagePopups) {
      const ttl = popup.expires - now;
      const life = Math.max(0, Math.min(1, ttl / this.damagePopupDuration));
      const floatOffset = (1 - life) * this.cellSize * 1.2;
      this.ctx.save();
      this.ctx.globalAlpha = life;
      this.ctx.fillStyle = '#ffeb3b';
      this.ctx.font = `bold ${Math.floor(this.cellSize * 0.75)}px "Segoe UI Emoji", "Apple Color Emoji", sans-serif`;
      this.ctx.fillText(
        `-${popup.value}`,
        popup.x * this.cellSize + this.cellSize / 2,
        popup.y * this.cellSize + this.cellSize / 2 - floatOffset
      );
      this.ctx.restore();
    }

    if (this.paused && !this.gameOver) {
      this.ctx.fillStyle = 'rgba(0,0,0,0.5)';
      this.ctx.fillRect(0, 0, canvas.width, canvas.height);
      this.ctx.fillStyle = '#fff';
      this.ctx.font = `bold ${this.cellSize * 1.5}px sans-serif`;
      this.ctx.fillText('暫停', canvas.width / 2, canvas.height / 2);
    }

    if (this.gameOver) {
      this.ctx.fillStyle = 'rgba(0,0,0,0.5)';
      this.ctx.fillRect(0, 0, canvas.width, canvas.height);
      this.ctx.fillStyle = '#fff';
      this.ctx.font = `bold ${this.cellSize * 1.2}px sans-serif`;
      this.ctx.textAlign = 'center';
      this.ctx.fillText('遊戲結束', canvas.width / 2, canvas.height / 2 - this.cellSize);
      this.ctx.fillText(`用時: ${this.elapsedTime} 秒`, canvas.width / 2, canvas.height / 2 + this.cellSize);
    }
  }
  public get skillSlots(): Array<SkillType | null> {
    const slots = [...this.skillQueue];
    while (slots.length < 3) {
      slots.unshift(null);
    }
    return slots;
  }

  public skillIcon(type: SkillType | null): string {
    if (!type) return '○';
    const map: Record<SkillType, string> = {
      glove: '🥊',
      staff: '🪄',
      bow: '🏹'
    };
    return map[type];
  }

  public get armorSlots(): number[] {
    return Array.from({ length: this.bossArmor }, (_, idx) => idx);
  }

  public isInvulnerable(): boolean {
    return Date.now() < this.invulnerableUntil;
  }

  private onItemCollected(): void {
    this.applyArrowProc();
  }

  private collectSkillItem(type: SkillType): void {
    this.skillQueue.push(type);
    if (this.skillQueue.length > 3) {
      this.skillQueue.shift();
    }
    if (this.skillQueue.length === 3) {
      this.handleSkillCombo([...this.skillQueue]);
      this.skillQueue = [];
    }
  }

  private handleSkillCombo(selection: SkillType[]): void {
    const gloveCount = selection.filter(item => item === 'glove').length;
    const staffCount = selection.filter(item => item === 'staff').length;
    const bowCount = selection.filter(item => item === 'bow').length;

    if (gloveCount === 3) {
      this.triggerHeavySmash();
    } else if (staffCount === 3) {
      this.startBurnEffect();
    } else if (bowCount === 3) {
      this.startArrowEffect();
    } else if (gloveCount === 1 && staffCount === 1 && bowCount === 1) {
      this.triggerPurify();
    }
  }

  private triggerHeavySmash(): void {
    const matterDamage = this.buffedAttackPower * 3;
    const actual = this.applyBossDamage(matterDamage, { location: this.snake[0], source: 'skill' });
    this.setSkillMessage('重擊', actual || 0);
  }

  private startBurnEffect(): void {
    this.clearBurnEffect();
    const tickDamage = Math.max(1, Math.floor(this.buffedAttackPower * 0.3));
    this.burnTicksRemaining = 10;
    this.setSkillMessage('燃燒', tickDamage);
    this.burnTickDamage = tickDamage;
    this.burnIntervalId = window.setInterval(() => {
      if (this.burnTicksRemaining <= 0) {
        this.clearBurnEffect();
        return;
      }
      const actual = this.applyBossDamage(tickDamage, { location: this.snake[0], source: 'burn' });
      this.burnTicksRemaining--;
      this.burnTickDamage = actual;
      if (actual <= 0) {
        this.clearBurnEffect();
      }
    }, 1000);
  }

  private startArrowEffect(): void {
    if (this.arrowTimeoutId) window.clearTimeout(this.arrowTimeoutId);
    this.arrowActiveUntil = Date.now() + 10000;
    this.setSkillMessage('追擊', null);
    this.arrowTimeoutId = window.setTimeout(() => {
      this.arrowActiveUntil = 0;
    }, 10000);
  }

  private applyArrowProc(): void {
    if (Date.now() >= this.arrowActiveUntil || this.bossHp <= 0) return;
    const damage = Math.max(1, Math.floor(this.bossHp * 0.01));
    this.applyBossDamage(damage, { location: this.snake[0], source: 'arrow' });
  }

  private triggerPurify(): void {
    const cleared = this.clearHazards();
    if (cleared <= 0) {
      this.setSkillMessage('淨化', 0);
      return;
    }
    let damage = Math.max(1, Math.floor((this.bossMaxHp * cleared) / 100));
    // 最多5%
    damage = Math.min(Math.floor((this.bossMaxHp * 5) / 100),damage);
    this.applyBossDamage(damage, { location: this.snake[0], source: 'skill' });
    this.setSkillMessage('淨化', damage);
  }

  private clearHazards(): number {
    const total = this.obstacles.length + this.mines.length + this.bats.length + this.skeletons.length;
    this.obstacles = [];
    this.mines = [];
    this.bats = [];
    this.skeletons = [];
    return total;
  }

  private startSkillSpawner(): void {
    clearInterval(this.skillIntervalId);
    this.spawnSkillItems();
    this.skillIntervalId = window.setInterval(() => this.spawnSkillItems(), 15000);
  }

  private spawnSkillItems(): void {
    if (this.gameOver) {
      this.skillItems = [];
      return;
    }
    this.skillItems = [];
    const types: SkillType[] = ['glove', 'staff', 'bow'];
    let tries = 0;
    const maxTries = 500;
    while (this.skillItems.length < 3 && tries < maxTries) {
      tries++;
      const pos: Point = {
        x: Math.floor(Math.random() * this.cols),
        y: Math.floor(Math.random() * this.rows)
      };
      if (this.skillItems.some(item => item.x === pos.x && item.y === pos.y)) continue;
      if (this.snake.some(p => p.x === pos.x && p.y === pos.y)) continue;
      if (this.obstacles.some(o => o.x === pos.x && o.y === pos.y)) continue;
      if (this.mines.some(m => m.x === pos.x && m.y === pos.y)) continue;
      if (this.bats.some(b => b.x === pos.x && b.y === pos.y)) continue;
      if (this.skeletons.some(s => s.x === pos.x && s.y === pos.y)) continue;
      if (this.specialFood && pos.x === this.specialFood.x && pos.y === this.specialFood.y) continue;
      if (pos.x === this.food.x && pos.y === this.food.y) continue;
      const type = types[Math.floor(Math.random() * types.length)];
      this.skillItems.push({ x: pos.x, y: pos.y, type });
    }
  }

  private applyBossDamage(amount: number, options?: { location?: Point; source?: 'weapon' | 'burn' | 'arrow' | 'skill' }): number {
    if (this.gameOver || amount <= 0) return 0;
    if (Date.now() < this.invulnerableUntil) return 0;
    const satietyScaled = Math.floor(amount * this.getSatietyRatio());
    if (satietyScaled <= 0) return 0;
    const mitigated = Math.max(1, satietyScaled - this.bossArmor);
    this.bossHp = Math.max(0, this.bossHp - mitigated);
    const popupPoint = options?.location ?? this.snake[0];
    if (popupPoint) {
      this.addDamagePopup(popupPoint, mitigated);
    }
    if (options?.source === 'weapon' && mitigated > 0) {
      this.weaponDamageHits++;
      if (this.weaponDamageHits >= 5) {
        this.weaponDamageHits = 0;
        if (this.bossArmor > 0) this.bossArmor--;
      }
    }
    this.updateInterval();
    this.checkInvulnerability();
    if (this.bossHp <= 0) {
      this.endGame();
    }
    return mitigated;
  }

  private clearBurnEffect(): void {
    if (this.burnIntervalId) {
      clearInterval(this.burnIntervalId);
    }
    this.burnTicksRemaining = 0;
    this.burnIntervalId = 0;
    this.burnTickDamage = null;
  }

  private setSkillMessage(text: string, damage: number | null): void {
    this.skillMessage = { text, damage, expires: Date.now() + 2000 };
    if (this.skillMessageTimeoutId) {
      clearTimeout(this.skillMessageTimeoutId);
    }
    this.skillMessageTimeoutId = window.setTimeout(() => {
      this.skillMessage = undefined;
    }, 2000);
  }

  private checkInvulnerability(): void {
    if (this.isInvulnerable()) return;
    if (this.nextInvulnThreshold < 0) return;
    if (this.bossHp <= this.nextInvulnThreshold) {
      this.activateInvulnerability();
      this.nextInvulnThreshold -= this.bossMaxHp * 0.1;
    }
  }

  private activateInvulnerability(): void {
    this.invulnerableUntil = Date.now() + 5000;
    if (this.invulnTimeoutId) {
      clearTimeout(this.invulnTimeoutId);
    }
    this.invulnTimeoutId = window.setTimeout(() => {
      this.invulnerableUntil = 0;
    }, 5000);
  }
  @HostListener('window:keydown', ['$event'])
  onKeydown(event: KeyboardEvent): void {
    if (this.navigationKeys.has(event.key)) {
      event.preventDefault();
    }
    if (event.key === ' ') { this.togglePause(); return; }
    const newDir = { x: this.direction.x, y: this.direction.y };
    switch (event.key) {
      case 'ArrowUp': newDir.x = 0; newDir.y = -1; break;
      case 'ArrowDown': newDir.x = 0; newDir.y = 1; break;
      case 'ArrowLeft': newDir.x = -1; newDir.y = 0; break;
      case 'ArrowRight': newDir.x = 1; newDir.y = 0; break;
      default: return;
    }
    if (this.snake.length > 1 &&
      newDir.x === -this.direction.x &&
      newDir.y === -this.direction.y) {
      return;
    }
    this.nextDirection = newDir;
  }

  public togglePause(): void {
    if (this.gameOver) return;
    if (this.paused) this.updateInterval();
    else clearInterval(this.intervalId);
    this.paused = !this.paused;
  }

  /**
   * Adjusts game loop interval according to boss HP percentage.
   * At full HP speed=1x (interval=baseInterval), at 0 HP speed=1.5x.
   */
  private updateInterval(): void {
    clearInterval(this.intervalId);
    const hpRatio = this.bossHp / this.bossMaxHp;
    const speedFactor = 1 + (1 - hpRatio) * 0.5;
    const interval = this.baseInterval / speedFactor;
    this.intervalId = window.setInterval(() => this.gameLoop(), interval);
  }

  private endGame(): void {
    clearInterval(this.intervalId);
    clearInterval(this.specialIntervalId);
    clearInterval(this.skillIntervalId);
    this.clearBurnEffect();
    if (this.arrowTimeoutId) clearTimeout(this.arrowTimeoutId);
    if (this.skillMessageTimeoutId) clearTimeout(this.skillMessageTimeoutId);
    if (this.invulnTimeoutId) clearTimeout(this.invulnTimeoutId);
    this.gameOver = true;
    this.paused = true;
    clearInterval(this.gameTimerId);
    clearInterval(this.batIntervalId);
  }

  private spawnSpecial(): void {
    if (this.specialFood) return;
    let pos: Point;
    do {
      pos = { x: Math.floor(Math.random() * this.cols), y: Math.floor(Math.random() * this.rows) };
    } while (
      this.snake.some(s => s.x === pos.x && s.y === pos.y) ||
      (pos.x === this.food.x && pos.y === this.food.y)
    );
    // random special types only 1,2 (obstacles/mines handled via HP thresholds)
    const types = [1, 2];
    const type = types[Math.floor(Math.random() * types.length)];
    this.specialFood = { ...pos, type };
  }

  private consumeSpecial(): void {
    const t = this.specialFood!.type;
    if (t === 1) {
      // attack buff +50% for 10s
      this.removeTailSegments(1);
      this.attackBuffFactor = 1.5;
      setTimeout(() => { this.attackBuffFactor = 1; }, 10000);
    } else if (t === 2) {
      // shield for 10s
      this.removeTailSegments(1);
      this.shieldActive = true;
      setTimeout(() => { this.shieldActive = false; }, 10000);
    } else if (t === 3) {
      // obstacle: normally net -1 segment, with shield reduce by 1 (net 0)
      const pops = this.shieldActive ? 1 : 2;
      this.removeTailSegments(pops);
    } else if (t === 4) {
      // mine: normally net -2 segments, with shield net -1
      const pops = this.shieldActive ? 2 : 3;
      this.removeTailSegments(pops);
    }
    this.specialFood = undefined;
  }

  /** Spawn 10 obstacles when boss HP threshold reached */
  private spawnObstacles(): void {
    this.obstacles = [];
    const head = this.snake[0];
    const avoid = new Set<string>();
    for (let i = 1; i <= 5; i++) {
      const ax = (head.x + this.direction.x * i + this.cols) % this.cols;
      const ay = (head.y + this.direction.y * i + this.rows) % this.rows;
      avoid.add(`${ax},${ay}`);
    }
    const maxTries = 500;
    let tries = 0;
    while (this.obstacles.length < 10 && tries < maxTries) {
      tries++;
      const pos: Point = {
        x: Math.floor(Math.random() * this.cols),
        y: Math.floor(Math.random() * this.rows)
      };
      const key = `${pos.x},${pos.y}`;
      if (avoid.has(key)) continue;
      if (this.snake.some(s => s.x === pos.x && s.y === pos.y)) continue;
      if (this.mines.some(m => m.x === pos.x && m.y === pos.y)) continue;
      if (this.bats.some(b => b.x === pos.x && b.y === pos.y)) continue;
      if (this.skeletons.some(s => s.x === pos.x && s.y === pos.y)) continue;
      if (this.specialFood && pos.x === this.specialFood.x && pos.y === this.specialFood.y) continue;
      if (pos.x === this.food.x && pos.y === this.food.y) continue;
      if (this.obstacles.some(o => o.x === pos.x && o.y === pos.y)) continue;
      this.obstacles.push(pos);
    }
  }
  /** Spawn 2 mines every 5s when boss HP ≤20%; clear otherwise */
  private spawnMines(): void {
    if (this.bossHp > this.bossMaxHp * 0.2) {
      this.mines = [];
      return;
    }
    const head = this.snake[0];
    const avoid = new Set<string>();
    for (let i = 1; i <= 5; i++) {
      const ax = (head.x + this.direction.x * i + this.cols) % this.cols;
      const ay = (head.y + this.direction.y * i + this.rows) % this.rows;
      avoid.add(`${ax},${ay}`);
    }
    for (let i = 0; i < 2; i++) {
      let pos: Point;
      do {
        pos = {
          x: Math.floor(Math.random() * this.cols),
          y: Math.floor(Math.random() * this.rows)
        };
      } while (
        this.snake.some(s => s.x === pos.x && s.y === pos.y) ||
        avoid.has(`${pos.x},${pos.y}`) ||
        this.obstacles.some(o => o.x === pos.x && o.y === pos.y) ||
        this.mines.some(m => m.x === pos.x && m.y === pos.y) ||
        (this.specialFood && pos.x === this.specialFood.x && pos.y === this.specialFood.y) ||
        (pos.x === this.food.x && pos.y === this.food.y)
      );
      this.mines.push(pos);
    }
  }

  /** Spawn 1 bat every 3s when boss HP ≤50%; clear otherwise */
  private spawnBats(): void {
    if (this.bossHp > this.bossMaxHp * 0.51) {
      this.bats = [];
      return;
    }
    let pos: Point;
    const head = this.snake[0];
    const avoid = new Set<string>();
    for (let i = 1; i <= 5; i++) {
      const ax = (head.x + this.direction.x * i + this.cols) % this.cols;
      const ay = (head.y + this.direction.y * i + this.rows) % this.rows;
      avoid.add(`${ax},${ay}`);
    }
    do {
      pos = {
        x: Math.floor(Math.random() * this.cols),
        y: Math.floor(Math.random() * this.rows)
      };
    } while (
      this.snake.some(s => s.x === pos.x && s.y === pos.y) ||
      avoid.has(`${pos.x},${pos.y}`) ||
      this.obstacles.some(o => o.x === pos.x && o.y === pos.y) ||
      this.mines.some(m => m.x === pos.x && m.y === pos.y) ||
      (this.specialFood && pos.x === this.specialFood.x && pos.y === this.specialFood.y) ||
      (pos.x === this.food.x && pos.y === this.food.y)
    );
    this.bats.push(pos);
  }

  /** Spawn 20 skeletons when boss HP ≤10% */
  private spawnSkeletons(): void {
    this.skeletons = [];
    const head = this.snake[0];
    const avoid = new Set<string>();
    for (let i = 1; i <= 5; i++) {
      const ax = (head.x + this.direction.x * i + this.cols) % this.cols;
      const ay = (head.y + this.direction.y * i + this.rows) % this.rows;
      avoid.add(`${ax},${ay}`);
    }
    for (let i = 0; i < 20; i++) {
      let pos: Point;
      do {
        pos = {
          x: Math.floor(Math.random() * this.cols),
          y: Math.floor(Math.random() * this.rows)
        };
      } while (
        this.snake.some(s => s.x === pos.x && s.y === pos.y) ||
        avoid.has(`${pos.x},${pos.y}`) ||
        this.obstacles.some(o => o.x === pos.x && o.y === pos.y) ||
        this.mines.some(m => m.x === pos.x && m.y === pos.y) ||
        (this.specialFood && pos.x === this.specialFood.x && pos.y === this.specialFood.y) ||
        (pos.x === this.food.x && pos.y === this.food.y) ||
        this.bats.some(b => b.x === pos.x && b.y === pos.y)
      );
      this.skeletons.push(pos);
    }
    this.skeletonsTriggered = true;
  }


  private scheduleEffectReset(factor: number): void {
    window.setTimeout(() => {
      this.effectSpeedFactor /= factor;
      this.updateInterval();
    }, 10000);
  }
}
